import React, { Component, Fragment } from "react";
import utils from "../../../../../utils/utilsProducaoSTI";

export default class TabelaADN extends Component {

    constructor(props) {
        super(props);
    }

    verificaValorTotalCategoria = (linhaAtuacao, valor) => {
        let valorTotalColuna = 0;
        if(valor && valor.modalidades.hasOwnProperty(linhaAtuacao)) {
            if(linhaAtuacao === "Consultoria em Tecnologia") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["horasTecnicas"];
            }
            else if(linhaAtuacao === "Metrologia") {
                valorTotalColuna = null
            }
            else if(linhaAtuacao === "Pesquisa, Desenvolvimento e Inovação") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["horasTecnicas"];
            }
            else if(linhaAtuacao === "Serviços Técnicos Especializados") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["numeroAtendimento"];
            }
        }
        return valorTotalColuna;
    }

    formataNumero = (meta, modal, coluna, mes) => {
        try {
            let valor = meta.modalidades[modal][coluna][mes];
            return valor.toLocaleString("pt-BR", { maximumFractionDigits: 2 , style: 'decimal' });
        }
        catch(erro) {
            // console.warn(">>>>>>>>>>>>>", erro, {meta, modal, coluna, mes})
            return 0;
        }

    }

    calculaPercentual = (meta, realizado) => {
        meta = Number(typeof meta === 'string' ? meta.replace('.', '').replace(',', '.') : meta)
        realizado = Number(typeof realizado === 'string' ? realizado.replace('.', '').replace(',', '.') : realizado)
        let acumulado = meta === 0 ? '-' : ((realizado / meta) * 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 }) + '%'
        return acumulado;
    }

    render() {

        let linhaAtuacao = [
            "Consultoria em Tecnologia",
            "Metrologia",
            "Pesquisa, Desenvolvimento e Inovação",
            "Serviços Técnicos Especializados",
            "Serviços Complementares"
        ]
        
        let { mesSelecionado, meses, meta, valor, unidade, isAcumulado, ultimoMesApurado } = this.props;

        let indiceMeta = meta.findIndex((nome) => nome.unidade === unidade);
        let indiceRealizado = valor.findIndex((nome) => nome.unidade === unidade);

        meta = meta[indiceMeta];
        // Sem planilha apurada para esta unidade (ex.: nenhum upload feito ainda),
        // mantém a tabela com Realizado zerado em vez de quebrar a tela.
        valor = valor[indiceRealizado] || { unidade, modalidades: {} };

        let mesSelecionadoRealizado = isAcumulado ? ultimoMesApurado : mesSelecionado

        return (
            <Fragment>

                <table border="1" className="table table-bordered table-hover table-sm table-striped">
                    <thead>
                        <tr>
                            <th colSpan="9" className="text-center">{valor.unidade}</th>
                        </tr>
                        <tr>
                            <th rowSpan="4">Áreas de Atuação</th>
                        </tr>
                        <tr>
                            <th colSpan="8" className="text-center">STI</th>
                        </tr>
                        <tr>
                            <th>Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>)</th>
                            <th>Realizado (<span style={{ textTransform: "uppercase" }}>{mesSelecionadoRealizado}</span>)</th>
                            <th>% (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>)</th>
                        </tr>
                    </thead>
                    <tbody>

                        {linhaAtuacao.map((linhaAtuacao, i) => {

                            let valorTotalColuna = this.verificaValorTotalCategoria(linhaAtuacao, valor);
                            let valorTotalColunaMeta = this.verificaValorTotalCategoria(linhaAtuacao, meta);
                            valorTotalColunaMeta = valorTotalColunaMeta ? utils.formataNumero(valorTotalColunaMeta[meses.indexOf(mesSelecionado)]) : 0
                            valorTotalColuna = valorTotalColuna ? utils.formataNumero(valorTotalColuna[meses.indexOf(mesSelecionadoRealizado)]) : 0

                            return (

                                <Fragment>
                                    <tr className="table caption-top table-primary text-center">
                                        <td className="text-center">{linhaAtuacao}</td>
                                        <td>{linhaAtuacao === "Metrologia" ? null : valorTotalColunaMeta}</td>
                                        <td>{linhaAtuacao === "Metrologia" ? null : valorTotalColuna}</td>
                                        <td>{linhaAtuacao === "Metrologia" ? null : this.calculaPercentual(valorTotalColunaMeta, valorTotalColuna)}</td>
                                    </tr>
                                    {meta && Object.keys(meta.modalidades).map((modal, j) => {
                                        let coluna = utils.verificaColuna(modal);

                                        if (utils.retornaCabecalho(modal) === linhaAtuacao) {
                                            let valorMeta                     = this.formataNumero(meta, modal, coluna, meses.indexOf(mesSelecionado));
                                            let valorRealizado                = this.formataNumero(valor, modal, coluna, meses.indexOf(mesSelecionadoRealizado));
                                            let percentualRealizado           = this.calculaPercentual(valorMeta, valorRealizado)
                                            let valorMetaRelatorios           = this.formataNumero(meta, modal, "relatoriosELaudos", meses.indexOf(mesSelecionado));
                                            let valorRealizadoRelatorios      = this.formataNumero(valor, modal, "relatoriosELaudos", meses.indexOf(mesSelecionadoRealizado));
                                            let percentualRealizadoRelatorios = this.calculaPercentual(valorMetaRelatorios, valorRealizadoRelatorios)
                                            return (
                                                <Fragment>
                                                    <tr>
                                                        <td>{modal}</td>
                                                        <td className="text-center">{valorMeta}</td>
                                                        <td className="text-center">{valorRealizado}</td>
                                                        <td className="text-center">{percentualRealizado}</td>
                                                    </tr>
                                                    {
                                                        modal === "Ensaios"
                                                            ?
                                                            <tr>
                                                                <td>{"Relatórios/Laudos"}</td>
                                                                <td className="text-center">{valorMetaRelatorios}</td>
                                                                <td className="text-center">{valorRealizadoRelatorios}</td>
                                                                <td className="text-center">{percentualRealizadoRelatorios}</td>
                                                            </tr>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        modal === "Calibração"
                                                            ?
                                                            <tr>
                                                                <td>{"Relatórios/Laudos"}</td>
                                                                <td className="text-center">{valorMetaRelatorios}</td>
                                                                <td className="text-center">{valorRealizadoRelatorios}</td>
                                                                <td className="text-center">{percentualRealizadoRelatorios}</td>
                                                            </tr>
                                                            :
                                                            null
                                                    }
                                                </Fragment>
                                            )
                                        }

                                    })}
                                </Fragment>

                            )

                        })}

                    </tbody>
                </table>

            </Fragment>
        )
    }
}